module.exports = __webpack_public_path__ + "static/media/concinnity-logo.4c822ef3.png";